<template>
  <div class="wrapper">

    <v-sidebar activeNavItem="dashboard"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Dashboard'" v-bind:path="'/dashboard'"></v-navbar>

      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <grid-layout
                :layout.sync="layout"
                :col-num="12"
                :row-height="10"
                :is-draggable="false"
                :is-resizable="false"
                :is-mirrored="false"
                :responsive="true"
                :vertical-compact="false"
                :preventCollision="true"
                :margin="[10, 5]"
                :use-css-transforms="true"
              >
                <grid-item v-for="item in layout"
                  :x="item.x"
                  :y="item.y"
                  :w="item.w"
                  :h="item.h"
                  :i="item.i"
                  :key="item.i">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title">{{item.i}}</h5>
                    </div>
                    <div class="card-body" v-bind:style="{ overflow: 'auto', maxHeight: ((item.h * 10) + 50) + 'px' }">
                      <component :is="item.c"></component>
                    </div>
                  </div>
                </grid-item>
              </grid-layout>
            </div>
          </div>
        </div>
      </div>

      <v-footer></v-footer>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

import VueGridLayout from 'vue-grid-layout';
import CarbonTonneKMWidget from './CarbonTonneKMWidget.vue'
import CostTonneKMWidget from './CostTonneKMWidget.vue'
import ActiveShipmentsWidget from './ActiveShipmentsWidget.vue'
import ShippingCostWidget from './ShippingCostWidget.vue'
import SupplierRFQWidget from './SupplierRFQWidget.vue'
import SupplierPerformanceWidget from './SupplierPerformanceWidget.vue'

import './dashboard.css'

export default {
  name: 'DashboardView',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,

    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,

    CarbonTonneKMWidget: CarbonTonneKMWidget,
    CostTonneKMWidget: CostTonneKMWidget,
    ActiveShipmentsWidget: ActiveShipmentsWidget,
    ShippingCostWidget: ShippingCostWidget,
    SupplierRFQWidget: SupplierRFQWidget,
    SupplierPerformanceWidget: SupplierPerformanceWidget
  },
  data: () => ({
    rows: [],
    layout: []
  }),
  async mounted() {
    this.layout = [
	    {"x":0,"y":0,"w":4,"h":18,"i":"Active Shipments", "c": "ActiveShipmentsWidget"},
	    {"x":4,"y":0,"w":8,"h":18,"i":"Grams of Co2 / Tonne KM", "c":"CarbonTonneKMWidget"},
	    {"x":0,"y":18,"w":8,"h":18,"i":"Shipping Cost", "c":"ShippingCostWidget"},
	    {"x":8,"y":18,"w":4,"h":18,"i":"Cost / Tonne KM", "c": "CostTonneKMWidget"},
	    {"x":0,"y":36,"w":5,"h":20,"i":"Supplier RFQs", "c": "SupplierRFQWidget"},
	    {"x":5,"y":36,"w":7,"h":20,"i":"Supplier Performance", "c": "SupplierPerformanceWidget"}
	];
  } // end mounted
}

</script>



// WEBPACK FOOTER //
// DashboardView.vue?2c381984